import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'fw/components';
import * as Modals from 'fw/globals/Modals';

class CorporateOwnersStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            corporateOwners: props.corporateOwners
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            corporateOwners: nextProps.corporateOwners
        });
    }

    onCorporateOwnerEdit = (index) => {
        this.props.onEdit(index);
    }

    onCorporateOwnerRemove = (index) => {
        let me = this;
        Modals.confirm("You are about to Delete this Corporate Owner. This Member will be removed from the system if you proceed.<br /><br />"
            + "If you wish to retain this Corporate Owner, please select No and you will be returned to the previous screen. If you wish to Discard this Member, select Yes.",
            function () {
                me.props.onRemove(index);
            }
        );
    }

    render() {
        let me = this;
        let rows = this.state.corporateOwners !== undefined && this.state.corporateOwners.map(function (item, index) {
            return (
                <tr key={index}>
                    <td>
                        {item.firstName}
                    </td>
                    <td>
                        {item.lastName}
                    </td>
                    <td>
                        {item.title}
                    </td>
                    <td style={{ textAlign: "center", width: '80px' }}>
                        {item.veteran === true &&
                            <FontAwesomeIcon icon={faCheck} size="lg" color="black" />
                        }
                        {item.veteran === false &&
                            <FontAwesomeIcon icon={faTimes} size="lg" color="black" />
                        }
                    </td>
                    <td style={{ textAlign: "center", width: '80px' }}>
                        {item.present === true &&
                            <FontAwesomeIcon icon={faCheck} size="lg" color="black" />
                        }
                        {item.present === false &&
                            <FontAwesomeIcon icon={faTimes} size="lg" color="black" />
                        }
                    </td>
                    <td style={{ textAlign: "center", width: '80px' }}>
                        {item.id === true &&
                            <FontAwesomeIcon icon={faCheck} size="lg" color="black" />
                        }
                        {item.id === false &&
                            <FontAwesomeIcon icon={faTimes} size="lg" color="black" />
                        }
                    </td>
                    <td style={{ textAlign: "center" }}>
                        {item.ownerPercent !== null && item.ownerPercent !== undefined ? item.ownerPercent + " %" : ""}
                    </td>
                    <td style={{ textAlign: "center" }}>
                        {item.votingPercent !== null && item.votingPercent !== undefined ? item.votingPercent + " %" : ""}
                    </td>
                    <td>
                        {!me.props.disabled &&
							<Button type="button" bsStyle="link" onClick={() => me.onCorporateOwnerEdit(index)}>
								<FontAwesomeIcon icon={faEdit} size="lg" color="black" />
							</Button>
						}
                        &nbsp;&nbsp;
                        {!me.props.disabled && item.fromSiteReview &&
							<Button type="button" bsStyle="link" onClick={() => me.onCorporateOwnerRemove(index)}>
                                <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
							</Button>
                        }
                    </td>
                </tr>
            );
        });

        return (
            <div style={{ marginTop: "10px" }}>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Title</th>
                            <th style={{ textAlign: "center", width: '80px' }}>Veteran</th>
                            <th style={{ textAlign: "center", width: '80px' }}>Present</th>
                            <th style={{ textAlign: "center", width: '80px' }}>I.D.</th>
                            <th style={{ textAlign: "center" }}>Owner %</th>
                            <th style={{ textAlign: "center" }}>Voting %</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default CorporateOwnersStaff;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/corporateOwners/CorporateOwnersStaff.js